var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return [
    "data-query",
    "chart-production",
    "comparison-analysis",
    "illegal-spots",
    "certificate-manage"
  ].indexOf(_vm.path) !== -1
    ? _c(
        "div",
        { staticClass: "feedback", on: { click: _vm.showModal } },
        [
          _c("img", {
            attrs: { src: require("@/assets/images/feedback.png"), alt: "" }
          }),
          _c("span", [_vm._v("反馈")]),
          _c(
            "a-modal",
            {
              staticClass: "feedbck-modal",
              attrs: {
                title: "意见反馈",
                footer: null,
                visible: _vm.visible,
                centered: true,
                destroyOnClose: true,
                "confirm-loading": _vm.confirmLoading
              },
              on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
            },
            [
              _c(
                "a-form-model",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-col": _vm.labelCol,
                    "wrapper-col": _vm.wrapperCol
                  }
                },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "标题", prop: "tel" } },
                    [
                      _c("a-input", {
                        attrs: { placeholder: "请输入标题" },
                        model: {
                          value: _vm.form.tel,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "tel", $$v)
                          },
                          expression: "form.tel"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "反馈类型", prop: "category" } },
                    [
                      _c(
                        "a-select",
                        {
                          attrs: {
                            placeholder: "请选择反馈类型",
                            dropdownClassName: "front-page"
                          },
                          model: {
                            value: _vm.form.category,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "category", $$v)
                            },
                            expression: "form.category"
                          }
                        },
                        [
                          _c("a-select-option", { attrs: { value: 1 } }, [
                            _vm._v(" 新增养殖 ")
                          ]),
                          _c("a-select-option", { attrs: { value: 2 } }, [
                            _vm._v(" 退出养殖 ")
                          ]),
                          _c("a-select-option", { attrs: { value: 3 } }, [
                            _vm._v(" 沟通咨询 ")
                          ]),
                          _c("a-select-option", { attrs: { value: 4 } }, [
                            _vm._v(" 其他 ")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "电子邮箱", prop: "email" } },
                    [
                      _c("a-input", {
                        attrs: { placeholder: "请输入电子邮箱" },
                        model: {
                          value: _vm.form.email,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "email", $$v)
                          },
                          expression: "form.email"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "链接", prop: "remark" } },
                    [
                      _c("a-input", {
                        attrs: { placeholder: "请输入链接" },
                        model: {
                          value: _vm.form.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      staticClass: "feeback-textarea",
                      attrs: { label: "反馈内容", prop: "content" }
                    },
                    [
                      _c("a-input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入反馈内容"
                        },
                        model: {
                          value: _vm.form.content,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "content", $$v)
                          },
                          expression: "form.content"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "附件" } },
                    [
                      _c(
                        "a-upload",
                        {
                          staticClass: "upload-file",
                          attrs: {
                            action: "#",
                            "file-liist": _vm.uploadedFileList,
                            customRequest: _vm.uploadFiles,
                            accept:
                              ".txt,.ppt,.pptx,.pdf,.doc,.docx,image/jpeg,image/jpg,image/png,video/mp4,.mp3,.xlsx,.xls",
                            "before-upload": _vm.beforeUpload,
                            remove: _vm.handleFileRemove
                          }
                        },
                        [
                          _c(
                            "a-button",
                            [
                              _c("a-icon", { attrs: { type: "upload" } }),
                              _vm._v(" 上传 ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "send" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.userFeedback }
                    },
                    [_vm._v(" 发送 ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }